module.exports = __webpack_public_path__ + "img/SEMINAR_AUTUMN_2026.cf53d4e6.jpg";